const firebaseConfig = {
    apiKey: "AIzaSyBLvStcsz9z59ywwC6IBtFmsKpfIq8cS6E",
    authDomain: "tour-x-traveler.firebaseapp.com",
    projectId: "tour-x-traveler",
    storageBucket: "tour-x-traveler.appspot.com",
    messagingSenderId: "721312920959",
    appId: "1:721312920959:web:8c3a4a640a430b7f63564a"
  };
  export default firebaseConfig;